import Moment from 'moment';

export const submissionsDateParamMappings = [
  {
    path: 'after',
    transform: ({ after }: { after: number }) =>
      after ? Moment.unix(after).utc().startOf('day').toISOString() : null,
  },
  {
    path: 'before',
    transform: ({ before }: { before: number }) =>
      before
        ? Moment.unix(before).utc().endOf('day').toISOString()
        : Moment().utc().endOf('day').toISOString(),
  },
];
